<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div class="text-left content-preview" v-html="node.content"></div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.buttonText"
        :label="'Button text'"
        persistent-placeholder
        :placeholder="'Confirm'"></v-text-field>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button background color'"
        :mode="'hex'"
        hide-alpha-slider
        v-model="node.buttonColor"></VaColorPicker>
    </div>
    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.placeholderText"
        :label="'Placeholder text'"
        persistent-placeholder
        :placeholder="'e.g., 12345'"></v-text-field>
    </div>
    <div>
      <v-select
        v-model="node.zipInputDisplayType"
        :items="zipInputTypes"
        :label="$t('shortcodes.live_chat_auto.input_question_display_type')"
        persistent-placeholder
        :placeholder="'Select input type'" />
    </div>
    <div>
      <v-radio-group v-model="overrideMode" class="mb-3 radio-group-override">
        <v-radio
          label="Override ZIP only"
          :value="ZIP_OVERRIDE_MODE.ZIP_ONLY"
          color="primary"
          hide-details="auto">
        </v-radio>
        <v-radio
          label="Override ZIP and auto-determine City & State"
          :value="ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION"
          color="primary"
          hide-details="auto">
        </v-radio>
      </v-radio-group>
    </div>
    <LiveChatFloatingText :node="node" />
  </div>
</template>

<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import LiveChatFloatingText from "./LiveChatFloatingText.vue";
  import { ZIP_INPUT_DISPLAY_TYPES, ZIP_OVERRIDE_MODE } from "./constant";

  export default {
    name: "LiveChatZipInput",
    components: { VaColorPicker, LiveChatFloatingText },

    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showEditor: !this.node?.content,
        zipInputTypes: ZIP_INPUT_DISPLAY_TYPES,
        ZIP_OVERRIDE_MODE,
      };
    },
    computed: {
      overrideMode: {
        get() {
          if (this.node.overrideZipAndLocation) return ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
          if (this.node.overrideZipOnly) return ZIP_OVERRIDE_MODE.ZIP_ONLY;
          return ZIP_OVERRIDE_MODE.ZIP_ONLY; // default
        },
        set(value) {
          this.node.overrideZipOnly = value === ZIP_OVERRIDE_MODE.ZIP_ONLY;
          this.node.overrideZipAndLocation = value === ZIP_OVERRIDE_MODE.ZIP_AND_LOCATION;
        },
      },
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateMessageContent(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";

  .message-item__label {
    @include text-caption-bold();
    color: get-color("subtitle");
    margin-bottom: 10px;
  }

  .radio-group-override {
    margin-top: 0 !important;
  }

  ::v-deep .v-radio {
    .v-label {
      @include text-body-2();
      color: var(--v-body-base) !important;
    }
  }
</style>
